// extracted by mini-css-extract-plugin
export default {"subsidinartTable_name":"subsidinary_subsidinartTable_name__atgmQ","subsidinartTable_actions":"subsidinary_subsidinartTable_actions__wxbU8"};